import(/* webpackMode: "eager" */ "/app/apps/ashtrom-4rent/app/[locale]/not-found.tsx");
